<template>
  <div class="text-13 h-6 flex items-center">
    Create PDF
    <div class="px-1">
      <b>{{ item?.payload?.file_name }}</b>
    </div>
    and store in variable
    <div class="px-1">
      <b>{{ item?.payload?.variable }}</b>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentPDFOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  computed: {
    payload() {
      return this.item.payload;
    },
  },
};
</script>
